module.exports = __webpack_public_path__ + "media/images/favicons/favicon-5c28d10ae311481b75cc175b675d4718.ico";